import * as Yup from 'yup'

const phoneRegExp = /^(\+98|0)?9\d{9}$/g

// const checkCodeMeli = (code)=>{
//   var L = code.length;

//   if (L < 8 || parseInt(code, 10) == 0) return false;
//   code = ("0000" + code).substr(L + 4 - 10);
//   if (parseInt(code.substr(3, 6), 10) == 0) return false;
//   var c = parseInt(code.substr(9, 1), 10);
//   var s = 0;
//   for (var i = 0; i < 9; i++) s += parseInt(code.substr(i, 1), 10) * (10 - i);
//   s = s % 11;
//   return (s < 2 && c == s) || (s >= 2 && c == 11 - s);
//   return true;
// }
export const replayMessageSchema = Yup.object().shape({
    text: Yup.string().required('این فیلد الزامی است'),
})
export const LoginSchema = Yup.object().shape({
    phone_number: Yup.string()
        // .matches(phoneRegExp, "شماره همراه صحیح وارد نمایید")
        .min(10, 'شماره موبایل صحیح وارد نمایید')
        .max(12, 'شماره موبایل صحیح وارد نمایید')
        .required('فیلد اجباری!'),
})

export const userSchema = Yup.object().shape({
    name: Yup.string()
        .required('فیلد اجباری!')
        .nullable(true),
    national_code: Yup.string()
        .nullable(true)
        .required('فیلد اجباری!')
        .min(10, 'کد ملی خود را به طور کامل وارد کنید')
        .max(10, 'تعداد ارقام کد ملی شما بیش از حد مجاز می باشد'),
    address: Yup.string()
        .required('فیلد اجباری!')
        .nullable(true),
})

export const companySchema = Yup.object().shape({
    name: Yup.string()
        .required('فیلد اجباری!')
        .nullable(true),
    economic_code: Yup.string()
        .nullable(true)
        .required('فیلد اجباری!')
        .min(11, 'کد اقتصادی خود را به طور کامل وارد کنید')
        .max(11, 'تعداد ارقام کد اقتصادی شما بیش از حد مجاز می باشد'),
    address: Yup.string()
        .required('فیلد اجباری!')
        .nullable(true),
})

export const verifyNumberSchema = Yup.object().shape({
    code: Yup.number(),
})

export const editUserSchema = Yup.object().shape({
    phone_number: Yup.string()
        // .matches(phoneRegExp, "شماره همراه صحیح وارد نمایید")
        .min(10, 'شماره موبایل صحیح وارد نمایید')
        .max(12, 'شماره موبایل صحیح وارد نمایید'),
})
export const addNewUserSchema = Yup.object().shape({
    phone_number: Yup.string()
        // .matches(phoneRegExp, "شماره همراه صحیح وارد نمایید")
        .min(10, 'شماره موبایل صحیح وارد نمایید')
        .max(12, 'شماره موبایل صحیح وارد نمایید')
        .required('فیلد اجباری!'),
    name: Yup.string()
        .required('فیلد اجباری!')
        .nullable(true),
    role: Yup.string()
        .ensure()
        .required('لطفا یک مورد انتخاب نمایید'),
})

export const addOrderSchema = Yup.object().shape({
    description: Yup.string().required('لطفا توضیحات را وارد نمایید'),
})

export const addProductSchema = Yup.object().shape({
    number_of_boxes: Yup.number()
        .required('تعداد بسته ارسالی را وارد نمایید')
        .min(0, 'عدد بزرگتر از صفر وارد نمایید'),
    cargo_number: Yup.number()
        .required('تعداد بسته ارسالی را وارد نمایید')
        .min(0, 'عدد بزرگتر از صفر وارد نمایید'),
})
